declare global {
  interface Window {
    DD_RUM?:
      | {
          addError: (error: Error, context?: Record<string, unknown>) => void;
          addTiming: (timingName: string, timing: any) => void;
          onReady: (fn: () => void) => void;
        }
      | undefined;
  }
}

export function logError(error: Error, options?: Record<string, unknown>) {
  if (typeof window?.DD_RUM !== 'object') return;

  if (typeof window.DD_RUM.addError !== 'function') return;

  window.DD_RUM.addError(error, options);
}

export function addCustomTiming(timingName: string, timing: any) {
  if (typeof window?.DD_RUM !== 'object') return;

  window.DD_RUM?.onReady(() => {
    window.DD_RUM?.addTiming(timingName, timing);
  });
}
